var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-local-offer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.41 12.08L14.41 3.08C14.05 2.72 13.55 2.5 13 2.5H6C4.9 2.5 4 3.4 4 4.5V11.5C4 12.05 4.22 12.55 4.59 12.92L13.59 21.92C13.95 22.28 14.45 22.5 15 22.5C15.55 22.5 16.05 22.28 16.41 21.91L23.41 14.91C23.78 14.55 24 14.05 24 13.5C24 12.95 23.77 12.44 23.41 12.08ZM15 20.51L6 11.5V4.5H13V4.49L22 13.49L15 20.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.5 9.5C10.3284 9.5 11 8.82843 11 8C11 7.17157 10.3284 6.5 9.5 6.5C8.67157 6.5 8 7.17157 8 8C8 8.82843 8.67157 9.5 9.5 9.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.c2db56a7ce620737cdd68e712760f8bd.svg";
export { ForwardRef as ReactComponent };